module.exports = __webpack_public_path__ + "img/tpc-brochures-2.59e0a9ff.jpg";